export default "__VITE_ASSET__CA6oA5bJ__"